import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Image, Row } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { TaskNameMapper } from '../../../hooks/types/response';
import { Body, CardContainer, Header } from '../styles';
import { SVGMapper, Style } from './types';

interface EndStateCardProps {
	task_name: TaskNameMapper.Lift | TaskNameMapper.Lower;
	svgMapper: SVGMapper;
}

export const EndStateCard: React.FC<EndStateCardProps> = ({ svgMapper, task_name }) => {
	const {
		libertyMutualResult: { summary }
	} = useLibertyMutualSubStepsContext();

	const endStateSVGAbsoluteValues: Style = {
		[TaskNameMapper.Lift]: {
			distance: {
				fontWeight: 400,
				position: 'absolute',
				bottom: '2%',
				left: '46%'
			},
			height: {
				fontWeight: 400,
				position: 'absolute',
				bottom: '35%',
				left: '75%'
			}
		},
		[TaskNameMapper.Lower]: {
			distance: {
				fontWeight: 400,
				position: 'absolute',
				bottom: '2%',
				left: '46%'
			},
			height: {
				fontWeight: 400,
				position: 'absolute',
				bottom: '22%',
				left: '75%'
			}
		}
	};

	return (
		<CardContainer
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between'
			}}
		>
			<Header>{I18n.get('End state')}</Header>
			<Body style={{ padding: '1rem 3rem 2rem 3rem' }}>
				<Row justify="center" align="middle">
					<Image
						preview={false}
						draggable={false}
						alt={`${I18n.get('End hand distance')} ${I18n.get('End hand height')}`}
						src={svgMapper[task_name].end}
						width="140px"
					/>
					<span style={endStateSVGAbsoluteValues[task_name].distance}>{summary.end_hand_distance ?? 0}</span>
					<span style={endStateSVGAbsoluteValues[task_name].height}>{summary.end_hand_height ?? 0}</span>
				</Row>
			</Body>
		</CardContainer>
	);
};
